import React, { memo } from 'react';
import classnames from 'classnames';
import { createUseStyles, Text } from '@Sage/hoi-poi-ui';
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'PasswordPolicies');
const PasswordPolicies = _ref => {
  let {
    password,
    policies = [],
    t,
    className
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, className)
  }, policies.map((policy, idx) => {
    const accepted = policy.condition(password);
    return /*#__PURE__*/React.createElement(Text, {
      key: idx,
      type: "caption",
      className: classnames(classes.policy, {
        [classes.on]: accepted,
        [classes.off]: !accepted
      })
    }, t(policy.literal, [policy.number]));
  }));
};
export default /*#__PURE__*/memo(PasswordPolicies);